import { IUnitModelCodeDto } from 'api/api';
import actionCreatorFactory from 'typescript-fsa';
import { constants } from './constants';

const actionCreator = actionCreatorFactory('unitModelCode');

export const getUnitModelCodesAction = actionCreator.async<undefined, IUnitModelCodeDto[]>(
	constants.GET_UNIT_MODEL_CODES
);
